export * from "./localstorage";
/** 支付方式 */
export enum Payments {
  BANK = 1,
  ALI = 2,
  WE_CHAT = 4,
  // USDT = 8,
  CRYPTO_COIN = 8,
  DIGITAL_RMB = 16,
  WX_GROUP = 6,
}

export const PaymentsMappingStr: Record<Payments, string> = {
  [Payments.BANK]: "银行卡",
  [Payments.ALI]: "支付宝",
  [Payments.WE_CHAT]: "微信",
  [Payments.CRYPTO_COIN]: "USDT地址",
  [Payments.DIGITAL_RMB]: "数字人民币",
  [Payments.WX_GROUP]: "微信聚合"
};

/** 订单是否可以拆分 */
export enum OrderType {
  /** 可拆分 */
  SEPARABLY = 1,
  /** 不可拆分 */
  INSEPARABLY = 0,
}

/** 订单状态 */
export enum OrderStatus {
  /** 卖家请求交易，等待卖家确认 */
  BUYER_REQUEST = "WaitingSellerConfirm",
  /** 卖家取消订单 */
  SELLER_CANCELED_DEAL = "SellerCancelsPurchase",
  /** 等待买家付款 */
  WAITING_FOR_TRANSFER = "WaitingBuyerPay",
  /** 买家未付款，买家取消交易 */
  BUYRER_CANCELD_DEAL = "BuyerNotPay",
  /** 买家支付时超时 */
  TIME_OVER = "BuyerPaymentExceedsTimeLimit",
  /** 买家确认已经付款 */
  TRANSFERRED = "BuyerConfirmsOrderHasBeenPaid",
  /** 卖家确认未收到付款 */
  SELLER_DID_NOT_RECEIVE = "SellerHasNotReceivedPayment",
  /** 订单有争议 */
  DISPUTING = "BuyerAppeals",
  /** 官方取消（作废）订单 */
  CANCELED_BY_OFFICIAL = "AdminCancelsOrder",
  /** 官方确认（完成）订单 */
  CONFIRMED_BY_OFFICIAL = "AdminCompletesOrder",
  /** 交易完成 */
  DEAL = "SellerCompletesOrder",
  /** 买家没有发起争议 */
  BUYER_NOT_APPEALS = "BuyerNotAppeals",
}

/** 交易中的订单的状态 */
export enum TransactingOrderStatus {
  // STEP 1
  HANGING = 1,
  BUYER_REQUEST = "WaitingSellerConfirm",
  // STEP 2
  SELLER_CANCELED_DEAL = "SellerCancelsPurchase",
  // STEP 3
  WAITING_FOR_TRANSFER = "WaitingBuyerPay",
  BUYRER_CANCELD_DEAL = "BuyerNotPay",
  TIME_OVER = "BuyerPaymentExceedsTimeLimit",
  // STEP 4
  TRANSFERRED = "BuyerConfirmsOrderHasBeenPaid",
  SELLER_DID_NOT_RECEIVE = "SellerHasNotReceivedPayment",
  DISPUTING = "BuyerAppeals",
  CANCELED_BY_OFFICIAL = "AdminCancelsOrder",
  CONFIRMED_BY_OFFICIAL = "AdminCompletesOrder",
  DEAL = "SellerCompletesOrder",
  BUYER_NOT_APPEALS = "BuyerNotAppeals",
}
